import React, { useCallback, useEffect } from 'react';
import { Button } from 'antd';
import { useLocation } from 'react-router-dom';

export function LoginPage() {
  const search = useLocation().search;
  const returnTo = new URLSearchParams(search).get('returnto');

  const startLogin = useCallback(() => {
    let url = (process.env.REACT_APP_KLT_BASE_API_URL || window.location.protocol + '//' + window.location.host) + '/login';
    if (returnTo) {
      url += '?returnto=' + returnTo;
    }
    window.location.href = url;
  }, [returnTo]);

  useEffect(() => {
    startLogin();
  }, [startLogin]);

  return (
    <div style={{ padding: '15rem 0', textAlign: 'center' }}>
      <h1>Giriş yapmalısınız!</h1>
      <h3>Uygulamayı kullanmak için giriş yapmalısınız.</h3>
      <Button type="default" style={{ marginTop: '3rem' }} onClick={startLogin}>
        Giriş yap
      </Button>
    </div>
  );
}
